import classNames from "classnames";
import React from "react";
import { handleGaCustomEvent } from "../../../utils/functions";

const FooterSocial = ({ className, ...props }) => {
  const classes = classNames("footer-social", className);

  return (
    <div {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <a
            href="https://www.instagram.com/olake_io/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              handleGaCustomEvent("external clicks", "Instagram click");
            }}
          >
            <img
              src={require("../../../assets/images/instagram.svg")}
              alt="instagram"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/datazipio"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              handleGaCustomEvent("external clicks", "LinkedIn click");
            }}
          >
            <img
              src={require("../../../assets/images/linkedin.svg")}
              alt="linkedin"
            />
          </a>
        </li>
        <li>
          <a
            href="https://x.com/_olake"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              handleGaCustomEvent("external clicks", "Twitter click");
            }}
          >
            <img
              src={require("../../../assets/images/twitter.svg")}
              alt="twitter"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/@olakeio"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              handleGaCustomEvent("external clicks", "Youtube click");
            }}
          >
            <img
              src={require("../../../assets/images/youtube.svg")}
              alt="youtube"
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default FooterSocial;
